module.exports = __webpack_public_path__ + "static/media/undraw_Video_call_re_4p26.5966e225.svg";